/* Barra de progresso + setas GDB (snippets/gdb-carousel-controls.liquid).
 * Mesma logica do script inline da product-list, mas em asset: nas
 * recomendacoes o HTML chega por fetch + morph e <script> inline nao roda.
 * Inicia cada .gdb-controls[data-gdb-auto] uma vez (data-gdb-ok). */
(function () {
  if (window.__gdbCarouselControls) return;
  window.__gdbCarouselControls = true;

  function init(ctr) {
    var host = ctr.closest('.section-resource-list');
    var track = host && host.querySelector('slideshow-slides');
    var bar = ctr.querySelector('.gdb-bar');
    var thumb = ctr.querySelector('.gdb-thumb');
    if (!track || !bar || !thumb) return;
    ctr.setAttribute('data-gdb-ok', '');
    var btns = ctr.querySelectorAll('.gdb-nav-btn');
    var prev = btns[0];
    var next = btns[1];

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) {
        ctr.style.visibility = 'hidden';
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }
      ctr.style.visibility = 'visible';
      var tw = Math.max((track.clientWidth / track.scrollWidth) * 100, 8);
      var leftPct = (track.scrollLeft / max) * (100 - tw);
      thumb.style.width = tw + '%';
      thumb.style.transform = 'translateX(' + (leftPct / tw) * 100 + '%)';
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByCard(dir) {
      var card = track.querySelector('.resource-list__slide');
      if (!card) return;
      var gap = parseInt(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
    requestAnimationFrame(update);
  }

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.gdb-controls[data-gdb-auto]:not([data-gdb-ok])').forEach(init);
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  function start() {
    scan();
    // Recomendacoes trocam o conteudo depois (morph): observa so esses hosts.
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      new MutationObserver(queue).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
